import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterCompaniesValue,
  UniversalFilterCompaniesModes,
  UniversalFilterCompaniesOnChange
} from './UniversalFilterCompanies.types';

import { useUniversalFilterCompanies } from './hooks/useUniversalFilterCompanies';

import { TeamsMultiSelect } from '../../../../../main/teams/helpers/TeamsMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterCompaniesProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterCompaniesValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterCompaniesOnChange;
}

function UniversalFilterCompanies({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterCompaniesProps) {
  const { modeOptions, filterState, handleModeChange, handleCompanyIdsChange } =
    useUniversalFilterCompanies({ filterStateCacheKey, filterValue, onChange });

  return (
    <UniversalFilterTemplate<UniversalFilterCompaniesModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [UniversalFilterCompaniesModes.CONTAINS_ANY_OF],
        filterState.mode
      ) ? (
        <TeamsMultiSelect
          value={filterState.companyNanoIds || []}
          autoFocus={autoFocus}
          onChange={handleCompanyIdsChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterCompanies;
